<template>
    <div class="row_center_center navbar">
        <backButton></backButton>
        <text class="navbar_title">{{ title }}</text>
    </div>
</template>
<script>
import backButton from "../backButton.vue";
export default {
    components: {
        backButton
    },
    props: {
        title: {
            type: String,
            default: ""
        }
    }
}
</script>
<style lang="">

</style>